<template>
    <div class="products_listing">
        <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
        <CommonHead></CommonHead>
        <div class="container">
            <b-breadcrumb :items="breadcrumb"></b-breadcrumb>
            <div class="mainproduct_listing">
			<h1 class="desktop-hide">Collections</h1>
                <div class="filterbar" v-if="isFilterLoading == false">
                    <a @click="togglefilter" class="filtershow" href="#">Filter<b-img class="plusfil" src="/shop/images/add.svg" alt="add"></b-img><b-img class="minusfil" src="/shop/images/minus.svg" alt="minus"></b-img></a>
                    <div class="allfilter">
                        <h6>QUICK SEARCH BY</h6>
						<div class="bookfilter">
							<h4>Collections</h4>
                            <select-2 url="/shop/api/product-books/fabric" v-model="form.booksdrop"  @input="selectCollections()">
                            </select-2>
						</div>
                        <div class="filter_by">
                            <h6>Filter By</h6>
                            <ul>
                                <li v-if="loadYear.length > 0"><a href="javascript:;" v-b-toggle.collapse-year>Year <b-img class="addicon" src="/shop/images/add.svg" fluid alt="add image"></b-img><b-img class="minusicon" src="/shop/images/minus.svg" fluid alt="minusimage"></b-img></a>
								<b-collapse id="collapse-year" accordion="my-accordion">
									<ul>
										<li v-for="(ly,lyk) in loadYear" :key="lyk"><md-checkbox :value="ly.BDATE" v-model="form.year" @change="loadFilter(form)">{{ly.BDATE}}</md-checkbox></li>
									</ul>
								</b-collapse>
								</li>
                                <li><a href="javascript:;" v-b-toggle.collapse-brand>Brand <b-img class="addicon" src="/shop/images/add.svg" fluid alt="add image"></b-img><b-img class="minusicon" src="/shop/images/minus.svg" fluid alt="minusimage"></b-img></a>
								<b-collapse id="collapse-brand" accordion="my-accordion">
									<ul>
										<li v-for="(lb,lbk) in loadBrands" :key="lbk"><md-checkbox :value="lb.NAME" v-model="form.brands" @change="loadFilter(form)">{{lb.NAME}}</md-checkbox></li>
									</ul>
								</b-collapse>
								</li>
								<li><a href="javascript:;" v-b-toggle.collapse-type>Type <b-img class="addicon" src="/shop/images/add.svg" fluid alt="add image"></b-img><b-img class="minusicon" src="/shop/images/minus.svg" fluid alt="minusimage"></b-img></a>
								<b-collapse id="collapse-type" accordion="my-accordion">
									<ul>
										<li v-for="(lt,ltk) in loadTypes" :key="ltk"><md-checkbox :value="lt.WEBTYPEVALUE" v-model="form.types" @change="loadFilter(form)">{{lt.WEBTYPEVALUE}}</md-checkbox></li>
									</ul>
								</b-collapse>
								</li>
                                <li><a href="javascript:;" v-b-toggle.collapse-status>Status <b-img class="addicon" src="/shop/images/add.svg" fluid alt="add image"></b-img><b-img class="minusicon" src="/shop/images/minus.svg" fluid alt="minusimage"></b-img></a>
								<b-collapse id="collapse-status" accordion="my-accordion">
									<ul>
										<li v-for="(ls,lsk) in loadStatus" :key="lsk"><md-checkbox :value="ls.PA" v-model="form.status" @change="loadFilter(form)">{{ls.PA}}</md-checkbox></li>
									</ul>
								</b-collapse>
								</li>
                                <li><a href="javascript:;" v-b-toggle.collapse-showroom>Showroom <b-img class="addicon" src="/shop/images/add.svg" fluid alt="add image"></b-img><b-img class="minusicon" src="/shop/images/minus.svg" fluid alt="minusimage"></b-img></a>
								<b-collapse id="collapse-showroom" accordion="my-accordion">
									<ul>
										<li><md-checkbox value="showroom" v-model="form.showroom" @change="loadFilter(form)">Display showroom items</md-checkbox></li>
									</ul>
								</b-collapse>
								</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="productsbar">
                    <div class="topsection">
                        <h1>Collections</h1>
                        <div class="sortby">
                            <label class="sort">Sort By: </label>
                            <v-select 
                                :options="sorting"
                                v-model="form.sort"
                                @input="loadFilter"
                                :reduce="sorting => sorting.value"
                                label="text"
                                :clearable="false"
                                :searchable="false"
                                placeholder="Sorting"
                            ></v-select>
                        </div>
                    </div>
                    <div class="productselectedfilter" v-if="(form.year.length > 0)||(form.brands.length > 0)||(form.types.length > 0)||(form.status.length > 0)||(form.showroom.length > 0)">
                        <b-form-tags v-if="form.year.length > 0" v-model="form.year" no-outer-focus class="mb-2">
                            <template v-slot="{removeTag }">
                                <ul class="list-tag">
                                <b-card
                                    v-for="tag in form.year"
                                    :key="tag"
                                    :id="`tag_${tag.replace(/\s/g, '_')}_`"
                                    tag="li"
                                    class="mt-1 mr-1"
                                    body-class="py-1 pr-2 text-nowrap">
                                    <strong>{{ tag }}</strong>
                                    <b-button
                                    @click="removeTag(tag);refreshTag(tag)"
                                    variant="link"
                                    size="sm"
                                    :aria-controls="`tag_${tag.replace(/\s/g, '_')}_`"
                                    ><b-img class="closefilter" src="/shop/images/close.svg" fluid alt="close image"></b-img></b-button>
                                </b-card>
                                </ul>
                            </template>
                        </b-form-tags>
                        <b-form-tags v-if="form.brands.length > 0" v-model="form.brands" no-outer-focus class="mb-2">
                            <template v-slot="{removeTag }">
                                <ul class="list-tag">
                                <b-card
                                    v-for="tag in form.brands"
                                    :key="tag"
                                    :id="`tag_${tag.replace(/\s/g, '_')}_`"
                                    tag="li"
                                    class="mt-1 mr-1"
                                    body-class="py-1 pr-2 text-nowrap">
                                    <strong>{{ tag }}</strong>
                                    <b-button
                                    @click="removeTag(tag);refreshTag(tag)"
                                    variant="link"
                                    size="sm"
                                    :aria-controls="`tag_${tag.replace(/\s/g, '_')}_`"
                                    ><b-img class="closefilter" src="/shop/images/close.svg" fluid alt="close image"></b-img></b-button>
                                </b-card>
                                </ul>
                            </template>
                        </b-form-tags>
                        <b-form-tags v-if="form.types.length > 0" v-model="form.types" no-outer-focus class="mb-2">
                            <template v-slot="{removeTag }">
                                <ul class="list-tag">
                                <b-card
                                    v-for="tag in form.types"
                                    :key="tag"
                                    :id="`tag_${tag.replace(/\s/g, '_')}_`"
                                    tag="li"
                                    class="mt-1 mr-1"
                                    body-class="py-1 pr-2 text-nowrap">
                                    <strong>{{ tag }}</strong>
                                    <b-button
                                    @click="removeTag(tag);refreshTag(tag)"
                                    variant="link"
                                    size="sm"
                                    :aria-controls="`tag_${tag.replace(/\s/g, '_')}_`"
                                    ><b-img class="closefilter" src="/shop/images/close.svg" fluid alt="close image"></b-img></b-button>
                                </b-card>
                                </ul>
                            </template>
                        </b-form-tags>
                        <b-form-tags v-if="form.status.length > 0" v-model="form.status" no-outer-focus class="mb-2">
                            <template v-slot="{removeTag }">
                                <ul class="list-tag">
                                <b-card
                                    v-for="tag in form.status"
                                    :key="tag"
                                    :id="`tag_${tag.replace(/\s/g, '_')}_`"
                                    tag="li"
                                    class="mt-1 mr-1"
                                    body-class="py-1 pr-2 text-nowrap">
                                    <strong>{{ tag }}</strong>
                                    <b-button
                                    @click="removeTag(tag);refreshTag(tag)"
                                    variant="link"
                                    size="sm"
                                    :aria-controls="`tag_${tag.replace(/\s/g, '_')}_`"
                                    ><b-img class="closefilter" src="/shop/images/close.svg" fluid alt="close image"></b-img></b-button>
                                </b-card>
                                </ul>
                            </template>
                        </b-form-tags>
                        <b-form-tags v-if="form.showroom.length > 0" v-model="form.showroom" no-outer-focus class="mb-2">
                            <template v-slot="{removeTag }">
                                <ul class="list-tag">
                                <b-card
                                    v-for="tag in form.showroom"
                                    :key="tag"
                                    :id="`tag_${tag.replace(/\s/g, '_')}_`"
                                    tag="li"
                                    class="mt-1 mr-1"
                                    body-class="py-1 pr-2 text-nowrap">
                                    <strong>{{ tag }}</strong>
                                    <b-button
                                    @click="removeTag(tag);refreshTag(tag)"
                                    variant="link"
                                    size="sm"
                                    :aria-controls="`tag_${tag.replace(/\s/g, '_')}_`"
                                    ><b-img class="closefilter" src="/shop/images/close.svg" fluid alt="close image"></b-img></b-button>
                                </b-card>
                                </ul>
                            </template>
                        </b-form-tags>
                        <a class="clearfilter" href="javascript:;" @click="resetFilter">Clear all</a>
                    </div>
                    <div class="mainproducts">
                        <p v-if="rows == 0">No results found.</p>
                        <div class="productbox" v-for="(lp,lpk) in loadProducts" :key="lpk">
                            <div class="brandlogos"><b-img class="brandlogoimg" :src="'/shop/images/logos/'+lp.RMCBRAND+'.png'"></b-img></div>
                            <a :href="lp.PAGEURL" class="imgbox">
                                <b-img class="proimg" :src="lp.MEDIUM_IMAGE" fluid :alt="lp.BOOKNAME"></b-img>
                                <span v-if="(lp.RMCLSCODE == 'LS25' || lp.RMCLSCODE == 'LS50' || lp.RMCLSCODE == 'AL')" class="saletag">Sale</span>
                                <span v-if="lp.ISNEW == true" class="newtag">New</span>
                            </a>
                            <div class="contentbox">
                                <h4><a :href="lp.PAGEURL">{{lp.BOOKNAME}}</a></h4>
                                <p v-if="lp.DESCRIPTION">{{lp.DESCRIPTION}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="propagination" v-if="loadProducts.length>0">
                        <div class="mt-3 custompage">
                            <b-pagination
                                v-model="currentPage"
                                @input="paginationChange"
                                :total-rows="rows"
                                :per-page="perPage"
                                align="center"
                                first-number
                                last-number
                            ></b-pagination>
                        </div>
                        <div class="itemspage">
                            <label class="pageitem">Items per page :</label>
                            <v-select 
                                :options="itemspage"
                                v-model="form.items"
                                @input="loadFilter"
                                :clearable="false"
                                :searchable="false"
                                placeholder="20"
                            ></v-select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <CommonFoot></CommonFoot>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import CommonHead from "@/components/CommonHead";
import CommonFoot from "@/components/CommonFoot";
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import Select2 from './Select2.vue';

export default {
  components: {
    CommonHead,
    CommonFoot,
    'v-select': vSelect,
    Select2,
    Loading
  },
  metaInfo: {
    title: 'RM COCO | Fabric Collections',
    meta: [{
        name: 'description',
        content: 'View our latest fabric collections, as well as classics from the past. Filter by brand and fabric type.'
    }],
  },
  computed:{
        ...mapGetters(["user"]),
        selectedPage(){
            return this.$route.path;
        }
  },
  mounted(){
        this.isLoading = true;
        this.isFilterLoading = true;
        this.PageloadFilter();
  },
  data(){
      return{
        activeClass:'active',
        loadProducts:[],
        loadYear:{},
        loadBrands:{},
        loadTypes:{},
        loadStatus:{},
        loadShowroom:{},
        rows: 20,
        perPage: 20,
        currentPage: 1,
        sorting: [
          { value: 'newest', text: 'Newest'},
          { value: 'abccode', text: 'Name (A-Z)'}
        ],
        itemspage: [
           '20','40','100'
        ],
        quantity: 1,
        form:{
            year: [],
            brands: [],
            types: [],
            status: [],
            showroom: [],
            booksdrop:"",
            items:20,
            sort:'newest',
            page:1 
        },
        isLoading: false,
        isFilterLoading: false,
        breadcrumb: [
            {
                text: 'Home',
                href: '/'
            },
            {
                text: 'Fabric Collections',
                active: true
            }
        ]
      };
  },
  methods: {
		togglefilter(){
            $(".allfilter").toggle();
            $(".filtershow").toggleClass("minusshow");
		},
        paginationChange(page){
            this.form.page = page;
            this.loadFilter();
        },
        selectCollections(){
            this.form.showroom=[];
            if(this.form.booksdrop != null && this.form.booksdrop !=''){
                let strbn = (this.form.booksdrop).toLowerCase();
                if(strbn.includes('showroom') === true){
                    this.form.showroom=['showroom'];
                }      
            }
            this.loadFilter();
        },
        loadfabricCollectionFilters(queryString){
            this.$store.dispatch("loadfabricCollectionFilters",queryString).then(loadcollectionfilters => {
                //this.loadYear = loadcollectionfilters.year;
                this.loadBrands = loadcollectionfilters.brands;
                this.loadTypes = loadcollectionfilters.types;
                this.loadStatus = loadcollectionfilters.status;
                this.loadShowroom = loadcollectionfilters.showroom;
            });
        },
		loadFilter(){
            this.isLoading = true;
            this.isFilterLoading = false;
            let url = [];
            if(this.form.booksdrop != ''){
                url["book"] = this.form.booksdrop;
            }
            if(this.form.year.length > 0){
                url["year"] = this.form.year.join();
            }
            if(this.form.brands.length > 0){
                url["brand"] = this.form.brands.join();
            }
            if(this.form.types.length > 0){
                url["type"] = this.form.types.join();
            }
            if(this.form.status.length > 0){
                url["status"] = this.form.status.join();
            }
            if(this.form.showroom.length > 0){
                url["showroom"] = this.form.showroom.join();
            }
            if(this.form.items != null){
                url["items"] = this.form.items;
            }
            if(this.form.sort != null){
                url["sort"] = this.form.sort;
            }
            url["page"] = this.form.page;
            this.$router.push({query: url });
            
            var queryString = Object.keys(url).map((key) => {
                return encodeURIComponent(key) + '=' + encodeURIComponent(url[key])
            }).join('&');
            this.$store.dispatch("loadfabricCollections",queryString).then(loadProducts => {
                this.rows = loadProducts.data.total;
                this.currentPage = this.form.page;
                this.perPage = this.form.items;
                this.loadProducts = loadProducts.data.products;
                this.isLoading = false;
            });
			this.AciveFilter();
        },
		PageloadFilter(){
            let url = [];
            if(this.$route.query.book){
                url["book"] = this.$route.query.book;
            }
            if(this.$route.query.year){
				url["year"] = this.$route.query.year;
				this.$root.$emit('bv::toggle::collapse', 'collapse-year');
            }
            if(this.$route.query.brand){
				url["brand"] = this.$route.query.brand;
				this.$root.$emit('bv::toggle::collapse', 'collapse-brand');
            }
            if(this.$route.query.type){
				url["type"] = this.$route.query.type;
				this.$root.$emit('bv::toggle::collapse', 'collapse-type');
            }
            if(this.$route.query.status){
				url["status"] = this.$route.query.status;
				this.$root.$emit('bv::toggle::collapse', 'collapse-status');
            }
            if(this.$route.query.showroom){
				url["showroom"] = this.$route.query.showroom;
            }
            if(this.$route.query.items){
                url["items"] = this.$route.query.items;
            }else{
                url["items"] = this.form.items;
            }
            if(this.$route.query.sort){
                url["sort"] = this.$route.query.sort;
            }else{
                url["sort"] = this.form.sort;
            }
            if(this.$route.query.page){
                url["page"] = this.$route.query.page;
                this.form.page = this.$route.query.page;
            }else{
                url["page"] = this.form.page;
            }
            
            this.$router.push({query: url });
            
            var queryString = Object.keys(url).map((key) => {
                return encodeURIComponent(key) + '=' + encodeURIComponent(url[key])
            }).join('&');
            this.loadfabricCollectionFilters(queryString);
            this.$store.dispatch("loadfabricCollections",queryString).then(loadProducts => {
                this.rows = loadProducts.data.total;
                this.currentPage = this.form.page;
                this.perPage = this.form.items;
                this.loadProducts = loadProducts.data.products;
                this.isLoading = false;
                this.isFilterLoading = false;
            });
			this.AciveFilter();
        },
		AciveFilter(){
            if(this.$route.query.book){
				this.form.booksdrop=this.$route.query.book;
            }
            if(this.$route.query.year){
				this.form.year=this.$route.query.year.split(',');
            }
            if(this.$route.query.brand){
				this.form.brands=this.$route.query.brand.split(',');
            }
            if(this.$route.query.type){
				this.form.types=this.$route.query.type.split(',');
            }
            if(this.$route.query.status){
				this.form.status=this.$route.query.status.split(',');
            }
            if(this.$route.query.showroom){
				this.form.showroom=this.$route.query.showroom.split(',');
            }
			if(this.$route.query.items){
			    this.form.items=this.$route.query.items;
			}
            if(this.$route.query.sort){
			    this.form.sort=this.$route.query.sort;
			}
        },
        refreshTag(tag){
            setTimeout(function () { this.loadFilter() }.bind(this), 500);
        },
        resetFilter(){
            this.form.booksdrop = '';
            this.form.year = [];
            this.form.brands = [];
            this.form.types = [];
            this.form.status = [];
            this.form.showroom=[];
            this.form.items=20;
            this.form.sort='newest';
            this.form.page=1; 
            this.loadFilter();
        }
    }
};
</script>
<style>
.brandlogos{
    background: #000;
    width: 100%;
    padding: 10px;
    color: #fff;
    display: flex;
    max-width: 265px;
    align-items: center;
    justify-content: center;
}
.brandlogoimg{
    width: 100%;
    height: auto;
}
@media only screen and (max-width: 1440px){
    .brandlogos {
        max-width: 225px;
    }
}
@media only screen and (max-width:1024px) and (min-width:768px){
    .brandlogos {
        max-width: 165px;
    }
}
@media only screen and (min-device-width: 1024px) and (max-device-width: 1366px) and (-webkit-min-device-pixel-ratio: 2){
    .brandlogos {
        max-width: 217px;
    }
}
@media only screen and (max-width:767px){
    .brandlogos {
        max-width: 182px;
    }
}
@media only screen and (max-width:375px){
    .brandlogos {
        max-width: 156px;
    }
}
</style>